function c(r) {
  var e;
  return typeof r != "string" || !r.includes("var(--mantine-scale)") ? r : (e = r.match(/^calc\((.*?)\)$/)) == null ? void 0 : e[1].split("*")[0].trim();
}
function u(r) {
  const e = c(r);
  return typeof e == "number" ? e : typeof e == "string" ? e.includes("calc") || e.includes("var") ? e : e.includes("px") ? Number(e.replace("px", "")) : e.includes("rem") ? Number(e.replace("rem", "")) * 16 : e.includes("em") ? Number(e.replace("em", "")) * 16 : Number(e) : NaN;
}
function s(r, e) {
  return r in e ? u(e[r]) : u(r);
}
function f(r, e) {
  const t = r.map((n) => ({
    value: n,
    px: s(n, e)
  }));
  return t.sort((n, i) => n.px - i.px), t;
}
function a(r) {
  return typeof r == "object" && r !== null ? "base" in r ? r.base : void 0 : r;
}
export {
  f as a,
  a as g,
  u as p
};
